import type { FC, SVGProps } from 'react';

export const EditPencilIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="32"
    height="32"
    fill="currentColor"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.91744 24.5681C6.98887 24.5681 7.0603 24.5609 7.13172 24.5502L13.1389 23.4967C13.2103 23.4824 13.2782 23.4502 13.3282 23.3967L28.4674 8.25737C28.5005 8.22433 28.5268 8.18508 28.5447 8.14188C28.5627 8.09867 28.5719 8.05236 28.5719 8.00558C28.5719 7.95881 28.5627 7.91249 28.5447 7.86929C28.5268 7.82608 28.5005 7.78684 28.4674 7.7538L22.5317 1.81451C22.4639 1.74665 22.3746 1.71094 22.2782 1.71094C22.1817 1.71094 22.0924 1.74665 22.0246 1.81451L6.8853 16.9538C6.83172 17.0074 6.79958 17.0717 6.7853 17.1431L5.73172 23.1502C5.69698 23.3415 5.7094 23.5385 5.76789 23.7239C5.82639 23.9094 5.9292 24.0777 6.06744 24.2145C6.30315 24.4431 6.59958 24.5681 6.91744 24.5681ZM9.32458 18.3395L22.2782 5.38951L24.896 8.00737L11.9424 20.9574L8.76744 21.5181L9.32458 18.3395ZM29.1424 27.5681H2.85672C2.22458 27.5681 1.71387 28.0788 1.71387 28.7109V29.9967C1.71387 30.1538 1.84244 30.2824 1.99958 30.2824H29.9996C30.1567 30.2824 30.2853 30.1538 30.2853 29.9967V28.7109C30.2853 28.0788 29.7746 27.5681 29.1424 27.5681Z"
    />
  </svg>
);
